import { SB } from '@play-co/replicant';

export const costumeSchema = {
  costume: SB.object({
    equipped: SB.string().optional(),

    inventory: SB.map(
      SB.object({
        species: SB.string(),
        level: SB.int(),
        quantity: SB.int(),
        createdAt: SB.int(),
        updatedAt: SB.int(),
      }),
    ),

    tickets: SB.map(
      SB.object({
        quantity: SB.int(),
        createdAt: SB.int(),
        updatedAt: SB.int(),
      }),
    ),
  }).optional(),
};
